export default (state = { startIndex: 1, isEmpty: true }, action = {}) => {
  switch (action.type) {
    case 'SEARCH_EMPTY_HANDLED':
      return {
        ...action.payload.data,
        isLoading: false,
        isEmpty: true,
      };
    case 'SEARCH_FETCHING': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'SEARCH_CACHE_RETRIEVED': {
      const { q, startIndex } = action.payload.data;
      return {
        ...state,
        startIndex,
        q,
        isLoading: false,
        isEmpty: false,
      };
    }
    case 'SEARCH_FETCHED': {
      const { q, startIndex, searchResponse } = action.payload.data;
      const { totalResults } = searchResponse.queries.request[0];

      const baseState = {
        [startIndex]: searchResponse,
        startIndex,
        q,
        isLoading: false,
        totalResults,
        isEmpty: false,
      };

      // "clear out" previous state, including cached search results pages, by not including it in the return object
      if (state.q !== q) {
        return {
          ...baseState,
        };
      }

      return {
        ...state,
        ...baseState,
      };
    }
    default:
      return state;
  }
};
